import { root } from './suggestions';

export const suggestions = {
  ...root,
};
